import AuthorizedUserService from './service';
import { GetAuthorizedUsersResponseData } from './types';

export const AUTHORIZED_USER_QUERY_KEYS = {
  GET_AUTHORIZED_USER: 'GET_AUTHORIZED_USER',
  GET_PROJECT_OWNER_AND_CURRENT_USER_PERMISSIONS: 'GET_PROJECT_OWNER_AND_CURRENT_USER_PERMISSIONS',
};

export class AuthorizedUserQueries {
  public static readonly getAuthorizedUsers = async (
    requestId: number,
    version: number
  ): Promise<GetAuthorizedUsersResponseData> => {
    const { data } = await AuthorizedUserService.getAuthorizedUsers(requestId, version);
    return data;
  };
  public static readonly getProjectOwnerAndCurrentUserPermissions = async (
    requestId: number,
    version: number
  ): Promise<GetAuthorizedUsersResponseData> => {
    const { data } = await AuthorizedUserService.getProjectOwnerAndCurrentUserPermissions(requestId, version);
    return data;
  };
}
